/** 向零截断到指定位小数（与 bhau converter 行为一致） */
export function truncateToDecimalPlaces(
  value: number,
  decimals: number,
): number {
  const factor = 10 ** decimals;
  return Math.trunc(value * factor) / factor;
}
